import React, { useState, useEffect } from 'react';
import { Card, Form, Spinner, Alert } from 'react-bootstrap';
import { getAdminConfigService } from '../../Services/AdminConfigService';

const AppSettings = () => {
    const [enabled, setEnabled] = useState(false);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    const adminConfigService = getAdminConfigService();

    useEffect(() => {
        const load = async () => {
            try {
                const isDashboard = await adminConfigService.isDashboardEnabled();
                setEnabled(isDashboard);
            } catch (err) {
                setError('Failed to load settings');
            } finally {
                setLoading(false);
            }
        };
        load();
    }, []);

    const handleToggle = async (e) => {
        const newValue = e.target.checked;
        setSaving(true);
        setError(null);
        setSuccess(null);
        try {
            const config = await adminConfigService.getApiConfig();
            await adminConfigService.updateApiConfig({
                ...config,
                dashboard: { enableDashboard: newValue }
            });
            setEnabled(newValue);
            setSuccess(`External Dashboard ${newValue ? 'enabled' : 'disabled'}`);
        } catch (err) {
            setError('Failed to save setting');
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return <div className="text-center py-4"><Spinner animation="border" size="sm" /></div>;
    }

    return (
        <div>
            {error && <Alert variant="danger" dismissible onClose={() => setError(null)}>{error}</Alert>}
            {success && <Alert variant="success" dismissible onClose={() => setSuccess(null)}>{success}</Alert>}

            <Card>
                <Card.Header><h6 className="mb-0">Dashboard Access</h6></Card.Header>
                <Card.Body>
                    <Form.Check
                        type="switch"
                        id="enableDashboard"
                        label={
                            <span>
                                <strong>External Dashboard</strong>
                                <span className="text-muted ms-2" style={{ fontSize: '0.85rem' }}>
                                    {enabled
                                        ? '— Dashboard link opens invest.rightspade.com'
                                        : '— Dashboard link shows "Coming Soon" modal'}
                                </span>
                            </span>
                        }
                        checked={enabled}
                        onChange={handleToggle}
                        disabled={saving}
                    />
                    {saving && <Spinner animation="border" size="sm" className="ms-2 mt-2" />}
                </Card.Body>
            </Card>
        </div>
    );
};

export default AppSettings;
